import * as Yup from 'yup';
import { TabOption } from '../../../../shared/components/FormTabHeader';

export interface IInspectionExpense {
    id: string;
    date: string;                   // LocalDate
    inspectionValidityDate: string; // LocalDate
    amount: number;                 // BigDecimal
    penalty: number;                // BigDecimal
    remainder: number;              // BigDecimal
    expenseName: string;
    branchId: string;
    documentNo: string;
    transactor: string;
    inspectionCompany: string;
    paymentDate: string;            // LocalDate
    payment: number;                // Integer
    paymentType: string;
    cashRegisterCode: string;
    iban: string;
    description: string;
    transactionKm: number;          // Integer
}


export const initialInspectionExpense: IInspectionExpense = {
    id: '',
    date: '',
    inspectionValidityDate: '',
    amount: 0,
    penalty: 0,
    remainder: 0,
    expenseName: '',
    branchId: '',
    documentNo: '',
    transactor: '',
    inspectionCompany: '',
    paymentDate: '',
    payment: 0,
    paymentType: '',
    cashRegisterCode: '',
    iban: '',
    description: '',
    transactionKm: 0,
};

export const validationInspectionExpense = Yup.object({
    date: Yup.string()
        .required('Tarih zorunludur'),

    inspectionValidityDate: Yup.string()
        .required('Muayene geçerlilik tarihi zorunludur'),

    amount: Yup.number()
        .typeError('Tutar sayısal olmalıdır')
        .required('Tutar zorunludur'),

    remainder: Yup.number()
        .typeError('Kalan tutar sayısal olmalıdır')
        .min(0, 'Kalan tutar 0 veya daha büyük olmalıdır')
        .default(0),

    expenseName: Yup.string()
        .required('Gider adı zorunludur')
        .max(100, 'Gider adı en fazla 100 karakter olabilir'),

});

export const tabOptions: TabOption<'form' | 'odeme' | 'arac'>[] = [
    { key: 'form', title: 'Bilgi Giriş', icon: 'bi bi-tools' },
    { key: 'odeme', title: 'Ödeme', icon: 'bi bi-tools' },
    { key: 'arac', title: 'Arac', icon: 'bi bi-tools' },
]
